import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import Notify from 'react-notification-alert';
import {request} from "../../helper/APIUtils";
import SingleFileSigner from "./component/SingleFileSigner"
import Table from "../../components/Table/Table";
import ReactLoading from 'react-loading';
import {SERVLET_PATH} from '../../constants'

class AliasSigner extends Component {

  constructor() {
    super();
    this.state = {
      initialized: false
    }

    this.sourceUrnMap = {
      usergb: "e-Fatura",
      earchive: "e-Arşiv",
      edespatch: "e-İrsaliye",
      archive: "Saklama",
      esevoucher: "e-SMM",
      epreceipt: "e-MM",
      eexchangecert: "e-Döviz",
      echeck: "e-Adisyon"
    }

    this.init = this.init.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.signCompleted = this.signCompleted.bind(this);
    this.onComplete = this.onComplete.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    let params = {
			url: '/signature/alias/nextUserOutboxEnvelope',
			method: "get"
    };

    request(params).then(response => {
      this.setState({
        initialized: true,
        loading: false,
        aliasList: response.data.aliasList,
        envelope: response.data.envelope
      });

      if (!response.data.envelope) {
        this.nextPage();
      }
    });

    this.setState({
      initialized: false,
      loading: true
    });
  }

  nextPage() {
    {
      setTimeout(function () {
        window.location.href = SERVLET_PATH + "/";
      }, 100);
    }
  }

  signCompleted(param) {

    let params = {
			url: '/signature/alias/writeSignedUserOutboxEnvelope',
      method: "post",
      data: {
        envelope: {
          id: this.state.envelope.id,
          value: param.signedDocument
        }
      }
    };

    return request(params);
  }

  onComplete() {
    this.setState({
      loading: false,
      aliasList: null,
      envelope: null
    });

    this.init();
  }

  renderEnvelopeExplanation() {
    return this.state.initialized && this.state.envelope && <Alert color="info">
      {this.sourceUrnMap[this.state.envelope.sourceUrn]} hizmeti ile ilgili aşağıdaki değişiklikler GİB'e bildirilecek. Akıllı kartınızı takınız ve zarfı imzalayınız.
    </Alert>
  }

  renderNoDataExplanation() {
    return this.state.initialized && !this.state.envelope && <Alert color="success">
      GİB'e bildirilecek hizmet bulunmamaktadır.
    </Alert>
  }

  renderAliasList() {

    const columns = [
			{
        Header: "Hizmet Türü",
        accessor: "",
				Cell: (item, i) => {
          return <div style={{textAlign: "center"}}>{this.sourceUrnMap[this.state.envelope.sourceUrn]}</div>
        },
        sortable: false,
        width: "100em"
			},
			{
        Header: "Etiket adı",
        accessor: "workScopeCode",
				Cell: (item, i) => {
          return <div style={{textAlign: "center"}}>{item.workScopeCode}</div>
        },
        sortable: false
			},
			{
        Header: "İşlem",
        accessor: "actionType",
				Cell: (item, i) => {
          return <div style={{textAlign: "center"}}>{item.actionType == "P" ? "Yeni etiket eklenecek" : item.actionType == "C" ? "Etiket silinecek" : ""} </div>;
        },
        sortable: false,
        width: "200em"
      }
    ]

    return this.state.aliasList && <Table columns={columns} content={this.state.aliasList} paginationEnabled={false}/>
  }

  renderSigner() {
    return this.state.envelope && <SingleFileSigner currentUser={this.props.currentUser} document={this.state.envelope.value} signCompleted={this.signCompleted} counterSign={true} omitXmlDeclaration={true} onComplete={this.onComplete}/>
  }

  render() {
    return (
      <div className="row">
        <Notify ref="notify"/>
        {this.state.alert}
				<div className="col-md-12">
					<div className="card">
						<div className="card-header ">
							<h4 className="card-title">GİB Bildirimi İmzala</h4>
						</div>
						<div className="card-body">
              {!this.state.loading && this.renderNoDataExplanation()}
              {!this.state.loading && this.renderEnvelopeExplanation()}
              {!this.state.loading && this.renderAliasList()}
              <br />
              {!this.state.loading && this.renderSigner()}
              {this.state.loading && <ReactLoading type="spinningBubbles" style={{width:"100px", height: "100px", margin: "100px auto 100px auto", fill: "#888"}}/>}
						</div>
					</div>
				</div>
			</div>
    );
  }
}

export default AliasSigner;
